"use client";

import { SanitizedContent } from "@/common/components-2/sanitized-content";
import { cn } from "@/services/styles/cn";

interface TopicProps {
  title: string;
  description: string;
  icon: string;
  className?: string;
}

export function AgendaItem({ title, description, icon, className }: TopicProps) {
  return (
    <div className={cn("flex gap-4 rounded-2xl bg-white p-4", className)}>
      <SanitizedContent
        as="div"
        content={icon}
        className="[&>svg]:min-h-[48px] [&>svg]:min-w-[48px] [&>svg]:fill-dodger-blue-700"
      />
      <div className="">
        <SanitizedContent as="div" content={title} className="mb-1 font-semibold text-2xl" />
        <SanitizedContent as="div" content={description} />
      </div>
    </div>
  );
}
